import React, { useEffect } from 'react';
import { Col, Loading, Row } from 'tdesign-react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import ListPanel from '@/components/ListPanel';
import { fetchServiceDiscoveryList } from '@/slices/serviceDiscoverySlice';
import NoData from '@/components/NoData';
import ClusterGroup from './ClusterGroup';

function ServiceDiscovery({ fetchServiceDiscoveryList, serviceDiscoveryList, loading }) {
  useEffect(() => {
    fetchServiceDiscoveryList();
  }, [fetchServiceDiscoveryList]);

  const loadingNode = loading && <Loading fullscreen loading />;
  const emptyNode = isEmpty(serviceDiscoveryList) && <NoData style={{ height: 400 }} />;

  return (
    loadingNode ||
    emptyNode || (
      <Root header='服务发现'>
        <Row gutter={[100, 60]}>
          {serviceDiscoveryList.map((item, index) => (
            <Col xs={6} xl={4} key={index}>
              <ClusterGroup
                cluster={item.clusterInfo}
                recoveryCluster={item.recoveryCluster}
                doRefresh={fetchServiceDiscoveryList}
              />
            </Col>
          ))}
        </Row>
      </Root>
    )
  );
}

const Root = styled(ListPanel)`
  .shadow-card-body {
    padding: 40px 60px;
  }
`;

export default connect(
  (state) => ({
    serviceDiscoveryList: state.serviceDiscovery.serviceDiscoveryList,
    loading: state.serviceDiscovery.loading,
  }),
  { fetchServiceDiscoveryList },
)(ServiceDiscovery);
